import React from "react";

/**
 * A reusable button component with loading state
 * @param {Object} props
 * @param {boolean} props.isLoading - Whether the button is in loading state
 * @param {boolean} props.disabled - Whether the button should be disabled
 * @param {function} props.onClick - Click handler
 * @param {string} props.className - CSS class names
 * @param {string} props.type - Button type (button, submit, reset)
 * @param {React.ReactNode} props.children - Button content
 * @param {Object} props.style - Inline styles
 */
export const LoadingButton = ({
    isLoading = false,
    disabled = false,
    onClick,
    className = "btn",
    type = "button",
    children,
    style = {},
    ...rest
}) => {
    return (
        <button
            type={type}
            className={`${className} ${isLoading ? "btn-loading" : ""}`}
            onClick={onClick}
            disabled={isLoading || disabled}
            style={{
                position: "relative",
                ...style,
            }}
            {...rest}
        >
            {isLoading && (
                <span className="btn-spinner">
                    <span className="spinner"></span>
                </span>
            )}
            <span style={{ opacity: isLoading ? 0.5 : 1 }}>{children}</span>
        </button>
    );
};

export default LoadingButton;
